import React, { forwardRef } from 'react'
import { X } from 'lucide-react'

export interface CloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: React.ReactNode
    size?: number
}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(({ icon, size = 24, className = '', style, ...props }, ref) => {
    return (
        <button
            ref={ref}
            type="button"
            aria-label="Close"
            className={`flex shrink-0 cursor-pointer items-center justify-center rounded-xl border-none bg-default p-1 text-default-foreground transition-colors duration-150 hover:bg-default-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface ${className}`}
            style={{ width: size, height: size, ...style }}
            {...props}
        >
            {icon || <X size={16} strokeWidth={1.5} />}
        </button>
    )
})

CloseButton.displayName = 'CloseButton'
